export const tinymceApiKey = "l4p3cq5yxpphcob55ysp4vlsfge3994vsnkr45a6aul0m5eu";

export const tinymceConfig = {
    language: "ru",
    selector: "#m-write-explanatory-editor",
    height: 284,
    statusbar: false,
    plugins: "lists, table",
    toolbar:
        "insertfile undo redo | bold italic underline strikethrough | fontsizeselect | fontselect | styleselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image table",
    content_style: "body { font-family: Arial; font-size: 13px }",
    mobile: {
        menubar: true,
        toolbar_mode: "floating",
    },
};
